// Components
import { UploadIdErrorComponent } from '../components/error/upload-id-error.component';
// Enumerations
import { UploadIdStatesEnumeration } from '../enumerations/upload-id-states.enumeration';
// Resolvers
import { getUploadIdFlowDataResolver } from '../resolvers/upload-id.resolver';
// Translations
import { FETCHING_DESCRIPTION, FETCHING_TITLE } from '../translations/upload-id.translations';

const UPLOAD_ID_LAYOUT_COMPONENT_PROPS = {
    externalFetchingConfiguration: {
      description: FETCHING_DESCRIPTION,
      title: FETCHING_TITLE,
    },
    errorComponent: UploadIdErrorComponent,
    fetchResolver: getUploadIdFlowDataResolver,
  },
  UPLOAD_ID_LAYOUT_ASSET_COMPONENT_PROPS = {
    [UploadIdStatesEnumeration.LANDING]: 'illustration_L3_generic_mobile-sms-default',
    [UploadIdStatesEnumeration.DIFFERENT_DATA]: '',
    [UploadIdStatesEnumeration.VERIFICATION]: '',
  };

export { UPLOAD_ID_LAYOUT_ASSET_COMPONENT_PROPS, UPLOAD_ID_LAYOUT_COMPONENT_PROPS };
